import { Link } from '@twistopayments/design-system/components/atoms/link'
import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { Article, ArticleHeadlineComponent } from '@twisto/api-cms'

import { useAdditionalData } from 'homepage/libs/context'
import { createIdFromSlugAndId } from 'homepage/utils'

import * as styles from './table-of-content.styles'

type Props = {
  article: Article
}

const isArticleHeadlineComponent = (
  component: unknown
): component is ArticleHeadlineComponent =>
  typeof component === 'object' &&
  component !== null &&
  (component as ArticleHeadlineComponent).__component === 'article.headline'

export const TableOfContent = ({ article }: Props) => {
  const headlines = article.contentSections.filter(isArticleHeadlineComponent)
  const { staticTexts } = useAdditionalData()
  if (headlines.length === 0) {
    return null
  }

  return (
    <nav>
      <Typography
        color="textSecondary"
        css={styles.tableOfContentLabel}
        variant="b2"
      >
        {staticTexts?.articleTableOfContentLabel || ''}
      </Typography>
      <ul css={styles.tableOfContentList}>
        {headlines.map(({ name, id, tag }) => (
          <li
            key={id}
            css={[
              styles.tableOfContentListItem,
              tag !== 'h2' && styles.tableOfContentListItemPadded,
            ]}
          >
            <Typography variant="b2">
              <Link href={`#${createIdFromSlugAndId(name, id)}`}>{name}</Link>
            </Typography>
          </li>
        ))}
      </ul>
    </nav>
  )
}
